<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body" style="height: 300px">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                  <el-row>
                      <el-col :span="12" class="item">
                          <el-form-item label="物品名称" required prop="name">
                              <el-input v-model="addForm.name"  placeholder="请输入物品名称"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="物品单价" required prop="price">
                              <el-input v-model="addForm.price" type="number"  placeholder="请输入物品单价"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="供应商" required prop="supplierCode">
                              <el-select v-model="addForm.supplierCode" placeholder="请选择供应商" style="width:100%">
                                  <el-option
                                          v-for="item in SupplierCodeValue"
                                          :key="item.supplierCode"
                                          :label="item.name"
                                          :value="item.supplierCode">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="物品类型" required prop="waresTypeCode">
                              <el-select v-model="addForm.waresTypeCode" placeholder="请选择物品类型" style="width:100%">
                                  <el-option
                                          v-for="item in WaresTypeCodeValue"
                                          :key="item.waresTypeCode"
                                          :label="item.name"
                                          :value="item.waresTypeCode">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12" class="item">
                          <el-form-item label="仓库" required prop="warehouseCode">
                              <el-select v-model="addForm.warehouseCode" placeholder="请选择仓库" style="width:100%">
                                  <el-option
                                          v-for="item in warehouseCodeValue"
                                          :key="item.warehouseCode"
                                          :label="item.name"
                                          :value="item.warehouseCode">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>


<!--                    <el-col :span="12" class="item">-->
<!--                      <el-form-item label="过期时间" required prop="expiresTime">-->
<!--                        <el-date-picker-->
<!--                            v-model="addForm.expiresTime"-->
<!--                            type="date"-->
<!--                            style="width:100%;"-->
<!--                            value-format="yyyy-MM-dd"-->
<!--                            placeholder="过期时间">-->
<!--                        </el-date-picker>-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->
                    <el-col :span="12" class="item">
                      <el-form-item label="生产企业">
                        <el-input v-model="addForm.manufacturer"  placeholder="请输入生产企业"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                      <el-form-item label="规格">
                        <el-input v-model="addForm.specifications"  placeholder="请输入规格"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                      <el-form-item label="备注">
                        <el-input v-model="addForm.remark"  placeholder="请输入备注"></el-input>
                      </el-form-item>
                    </el-col>


                  </el-row>
                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Add',
        props: ["SupplierCodeValue","WaresTypeCodeValue",'warehouseCodeValue'],
        data() {
            return {
                loading: false,
                floor:null,
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    price:'',
                    waresTypeCode:'',
                    supplierCode:'',
                    warehouseCode:'',

                  //expiresTime:'',
                  specifications:'',
                  manufacturer:'',
                  remark:'',


                },
                rules:{
                    warehouseCode:[
                        { required: true, message: '请选择仓库', trigger: 'blur' },
                    ],
                    price:[
                        { required: true, message: '请输入物品单价', trigger: 'blur' },
                        {
                            pattern: /^(\d?)+(\.\d{0,2})?$/,
                            message: '请输入正确的金额(保留两位小数)', trigger: 'blur'
                        },
                    ],
                    name:[
                        { required: true, message: '请输入物品名称', trigger: 'blur' },
                    ],
                    waresTypeCode:[
                        { required: true, message: '请选择物品类型', trigger: 'blur' },
                    ],
                    supplierCode:[
                        { required: true, message: '请选择供应商', trigger: 'blur' },
                    ],
                  // expiresTime:[
                  //   { required: true, message: '请输入过期时间', trigger: 'blur' },
                  // ],
                }
            }
        },

        methods: {
            init(){
                this.$refs.addForm.resetFields();

            },
            closeSelf() {
                this.$emit("closeAdd");
            },


            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        if(this.addForm ==""){
                            this.$message({type: 'info', message: '菜单不能为空'});
                            return ;
                        }
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Wares/Add2",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if (response.data.error == 1) {
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>



<style lang="scss" scoped>


</style>
